import {modelStudyCopy} from './locales/model-study.js';
import {modelStudyIds,studyModelNames} from './model-study-config.js';
export function modelStudyMarkup(language,demo,choice='default'){
 if(!modelStudyIds.includes(demo))return '';
 const c=modelStudyCopy[language==='ja'?'ja':'en'];
 return `<div class="model-study"><label for="study-model">${c.label}</label><select id="study-model">${studyModelNames.map(id=>`<option value="${id}" ${id===choice?'selected':''}>${c.models[id]}</option>`).join('')}</select><p data-model-note>${c.notes[choice]}</p>${demo==='sss'?`<p>${c.limit}</p>`:''}${demo==='wireframe'?`<p>${c.detail}</p>`:''}</div>`;
}
